/* ==========================================================================
   MERIDIO — Regole del carrello
   Due cose sole, applicate dopo ogni modifica del carrello:

   1. Massimo N orologi per ordine (i bracciali in regalo non contano).
   2. Un bracciale in regalo per ogni orologio.

   Il punto 2 serve perche lo sconto automatico "FUNE in regalo" NON aggiunge
   il bracciale: lo mette a zero se e gia nel carrello. Chi alzava la quantita
   dell'orologio dal carrello si ritrovava 3 orologi e un bracciale solo.

   REGOLA DI CASA: si ridisegna UNA VOLTA SOLA, alla fine.
   Le correzioni intermedie viaggiano senza `sections`. Ridisegnare a ogni
   passo faceva arrivare risposte vecchie dopo quelle nuove, e il cassetto
   restava vuoto con il totale giusto in fondo.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = document.getElementById('md-carrello-regole');
  if (!cfg) return;

  var MAX = parseInt(cfg.getAttribute('data-max'), 10) || 5;
  var FUNE_HANDLE = cfg.getAttribute('data-fune-handle') || '';
  var FUNE_VARIANTE = parseInt(cfg.getAttribute('data-fune-variante'), 10) || 0;
  /* Il gemello a 0 €: sull'offerta tre orologi il bundle mette nel carrello
     questo al posto del bracciale a pagamento, perche Shopify applica un solo
     sconto di classe prodotto per ordine e il regalo FUNE se lo prenderebbe
     tutto. Qui va riconosciuto come bracciale: altrimenti viene contato come
     orologio, il carrello ne aggiunge altri a pagamento e taglia pure gli
     orologi perche sfora il tetto. */
  var FUNE_OMAGGIO_HANDLE = cfg.getAttribute('data-fune-omaggio-handle') || '';
  var CHIAVE = cfg.getAttribute('data-chiave-proprieta') || 'Offerta';
  var ETICHETTA = cfg.getAttribute('data-etichetta-regalo') || '';
  var AVVISO = cfg.getAttribute('data-avviso-max') || 'Massimo {n} orologi per ordine.';

  if (!FUNE_HANDLE) return;

  function radice() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function json(url, corpo) {
    var opz = { headers: { Accept: 'application/json' } };
    if (corpo) {
      opz.method = 'POST';
      opz.headers['Content-Type'] = 'application/json';
      opz.body = JSON.stringify(corpo);
    }
    return fetch(url, opz).then(function (r) { return r.json(); });
  }

  function leggi() { return json(radice() + 'cart.js'); }

  function eBracciale(riga) {
    if (riga.handle === FUNE_HANDLE) return true;
    return FUNE_OMAGGIO_HANDLE !== '' && riga.handle === FUNE_OMAGGIO_HANDLE;
  }

  function orologi(c) {
    var n = 0;
    (c.items || []).forEach(function (r) { if (!eBracciale(r)) n += r.quantity; });
    return n;
  }

  /* Solo i bracciali arrivati come regalo. Uno comprato apposta ha altre
     proprieta e va lasciato in pace: e un acquisto del cliente. */
  function inRegalo(riga) {
    if (!eBracciale(riga)) return false;
    /* Il gemello a 0 € esiste solo come regalo: non c'e un caso in cui
       qualcuno lo abbia comprato apposta. */
    if (FUNE_OMAGGIO_HANDLE !== '' && riga.handle === FUNE_OMAGGIO_HANDLE) return true;
    if (!ETICHETTA) return true;
    return (riga.properties || {})[CHIAVE] === ETICHETTA;
  }

  function regalati(c) {
    var n = 0;
    (c.items || []).forEach(function (r) { if (inRegalo(r)) n += r.quantity; });
    return n;
  }

  function avvisa(testo) {
    var vecchio = document.querySelector('.md-carrello__avviso');
    if (vecchio) vecchio.remove();
    var casa = document.querySelector('cart-drawer .drawer__footer')
      || document.querySelector('.cart__footer')
      || document.querySelector('cart-drawer .drawer__inner');
    if (!casa) return;
    var p = document.createElement('p');
    p.className = 'md-carrello__avviso';
    p.setAttribute('role', 'status');
    p.textContent = testo;
    casa.insertBefore(p, casa.firstChild);
    window.setTimeout(function () { p.remove(); }, 4000);
  }

  var cassetto = function () { return document.querySelector('cart-drawer'); };

  function elenchiSezioni() {
    var d = cassetto();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (x) { return x.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* Un solo ridisegno, con sezioni chieste adesso: cosi quello che si vede
     e sempre l'ultimo stato del carrello, non una risposta arrivata tardi. */
  function ridisegnaOra(apri) {
    var ids = elenchiSezioni();
    return Promise.all([
      fetch(radice() + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }),
      leggi()
    ])
      .then(function (coppia) {
        var sezioni = coppia[0];
        var carrello = coppia[1];
        var d = cassetto();
        if (!d || typeof d.renderContents !== 'function') return false;

        /* `is-empty` viene scritto da Liquid al caricamento della pagina e
           nessuno lo toglie: ridisegnare cambia il contenuto del cassetto,
           non le classi di chi lo contiene. Finche resta, la regola
           `cart-drawer.is-empty .drawer__inner` schiaccia il riquadro a
           zero e le immagini (che sono `loading="lazy"`) non si caricano
           mai: la riga si vede senza foto. Dawn lo toglie nel suo
           product-form.js; qui passiamo da un'altra strada, quindi tocca
           a noi. Si rimette quando il carrello torna vuoto davvero. */
        d.classList.toggle('is-empty', (carrello.item_count || 0) === 0);
        /* renderContents apre gia il cassetto. Se non lo vogliamo aperto
           ridisegnamo a mano le stesse sezioni, senza aprirlo. */
        if (apri) {
          d.renderContents({ sections: sezioni });
        } else {
          d.getSectionsToRender().forEach(function (s) {
            var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            if (el && sezioni[s.id]) el.innerHTML = d.getSectionInnerHTML(sezioni[s.id], s.selector);
          });
        }
        subito(d);
        return true;
      })
      .catch(function () { return false; });
  }

  /* Le foto del carrello arrivano da Liquid con loading="lazy". Ha senso in
     una pagina lunga, non in un cassetto che si sta aprendo: il browser le
     carica solo quando entrano nello schermo, e un cassetto che scorre da
     destra (o una scheda in secondo piano) puo non farle entrare mai. Si
     vedono le righe con il buco al posto della foto.
     Qui diventano immediate: sono due o tre immagini piccole, gia in vista. */
  function subito(d) {
    var foto = d.querySelectorAll('.cart-item img');
    Array.prototype.forEach.call(foto, function (i) {
      if (i.getAttribute('loading') === 'lazy') i.setAttribute('loading', 'eager');
      i.setAttribute('fetchpriority', 'high');
      /* Riassegnare src forza il caricamento anche se il browser aveva gia
         deciso di rimandarlo. */
      if (!i.complete || !i.naturalWidth) i.src = i.src;
    });
  }

  var alLavoro = false;

  /* Corregge il carrello senza disegnare niente. Torna true se ha cambiato
     qualcosa, cosi chi chiama sa se vale la pena ridisegnare. */
  function correggi(giro, cambiato) {
    giro = giro || 0;
    if (giro > 5) return Promise.resolve(cambiato);

    return leggi().then(function (c) {
      var quanti = orologi(c);
      var i, r;

      /* 1 — troppi orologi: si taglia l'ultima riga che sfora. */
      if (quanti > MAX) {
        var extra = quanti - MAX;
        for (i = (c.items || []).length - 1; i >= 0; i--) {
          r = c.items[i];
          if (eBracciale(r)) continue;
          return json(radice() + 'cart/change.js', { id: r.key, quantity: Math.max(0, r.quantity - extra) })
            .then(function () {
              avvisa(AVVISO.replace('{n}', MAX));
              return correggi(giro + 1, true);
            });
        }
      }

      /* 2 — un bracciale in regalo per ogni orologio. */
      var regali = regalati(c);
      var attesi = Math.min(quanti, MAX);

      if (regali > attesi) {
        var togliere = regali - attesi;
        for (i = (c.items || []).length - 1; i >= 0; i--) {
          r = c.items[i];
          if (!inRegalo(r)) continue;
          return json(radice() + 'cart/change.js', { id: r.key, quantity: Math.max(0, r.quantity - togliere) })
            .then(function () { return correggi(giro + 1, true); });
        }
      }

      if (regali < attesi) {
        /* Se nel carrello ci sono gia i gemelli a 0 € siamo dentro l'offerta
           tre orologi: si completa con QUELLI, nello stesso colore. Mettere
           qui un bracciale a pagamento farebbe scattare il regalo FUNE, che
           si prenderebbe l'unico sconto di classe prodotto e farebbe saltare
           "il terzo orologio in regalo". */
        var variante = 0;
        for (i = 0; i < (c.items || []).length; i++) {
          if (FUNE_OMAGGIO_HANDLE !== '' && c.items[i].handle === FUNE_OMAGGIO_HANDLE) {
            variante = c.items[i].variant_id;
            break;
          }
        }
        if (!variante) variante = FUNE_VARIANTE;
        if (variante) {
          var prop = {};
          if (ETICHETTA) prop[CHIAVE] = ETICHETTA;
          return json(radice() + 'cart/add.js',
            { items: [{ id: variante, quantity: attesi - regali, properties: prop }] })
            .then(function () { return correggi(giro + 1, true); });
        }
      }

      limita(quanti);
      return cambiato;
    }).catch(function () { return cambiato; });
  }

  /* Il "+" si spegne quando non c'e piu spazio: meglio prevenire il gesto
     che correggerlo dopo. Il controllo vero resta comunque correggi(). */
  function limita(quanti) {
    var righe = document.querySelectorAll('cart-drawer .cart-item, .cart-item');
    Array.prototype.forEach.call(righe, function (riga) {
      var campo = riga.querySelector('input[name="updates[]"], .quantity__input');
      if (!campo) return;
      if (ETICHETTA && (riga.textContent || '').indexOf(ETICHETTA) !== -1) return;
      var mia = parseInt(campo.value, 10) || 0;
      var tetto = Math.max(mia, mia + (MAX - quanti));
      campo.setAttribute('max', tetto);
      var piu = riga.querySelector('button[name="plus"], .quantity__button[name="plus"]');
      if (piu) piu.disabled = mia >= tetto;
    });
  }

  /* L'unico ingresso pubblico: sistema il carrello e poi ridisegna una volta.
     La barra d'acquisto lo chiama dopo aver aggiunto, invece di disegnare
     per conto suo — era quello a lasciare il cassetto vuoto. */
  function sincronizza(opz) {
    opz = opz || {};
    if (alLavoro) return Promise.resolve();
    alLavoro = true;
    return correggi(0, false)
      .then(function (cambiato) {
        if (opz.apri || cambiato || opz.disegna) return ridisegnaOra(!!opz.apri);
      })
      .then(function () { alLavoro = false; })
      .catch(function () { alLavoro = false; });
  }

  window.MDCarrello = { sincronizza: sincronizza, massimo: MAX };

  /* Dawn annuncia gli aggiornamenti del carrello sul suo canale interno. */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { sincronizza({}); });
  }

  var attesa = null;
  function piuTardi() {
    if (attesa) clearTimeout(attesa);
    attesa = setTimeout(function () { sincronizza({}); }, 300);
  }

  function osserva() {
    var zona = document.querySelector('cart-drawer, #main-cart-items');
    if (zona && 'MutationObserver' in window) {
      new MutationObserver(piuTardi).observe(zona, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { osserva(); sincronizza({}); });
  } else {
    osserva();
    sincronizza({});
  }
})();
